const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const createNewTicket = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'CREATE_MESSAGE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'CREATE_MESSAGE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default createNewTicket;